import React , {Component} from "react"
import './styles.css'
import Asset4 from "../../assets/Client/04.png";
import Comment1 from "../../assets/Partenaire/install.png"
import Comment2 from "../../assets/Partenaire/call us.png"

import Mobile from "../../assets/Partenaire/Groupe 74.png";
import {RanaLahna} from "../Others/RanaLahnaComponent/RanaLahnaComponent";
import {Helmet} from "react-helmet";
import FavIcon from "../../assets/FavIcons/04.ico";


const Comment =({img , title , content , switche})=>{
    let classImg="col-lg-3 commentImage";
    let classContent="col-lg-6 commentContent text-black"
    if(switche){
        classImg+=" order-lg-2"
        classContent+=" order-lg-1"
    }
    return(
        <div className="d-lg-flex col-lg-12 commentSection mb-5 mb-lg-0" style={{ alignItems : 'center'}}>
            <img  className={classImg} src={img} alt=""/>
            <div className={classContent}>
                <div className="pt-3 pb-3" style={{fontSize : '2rem'}}>
                    {title}
                </div>
                <div>
                    {content}
                </div>
            </div>
        </div>
    )
}

export class Partenaire extends Component{
    constructor(props) {
        super(props);
    }
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title> ADSIL Partenaire</title>
                    <link rel="shortcut icon"  href={FavIcon} />
                </Helmet>
                <div className="col-12 text-black"  id="partenaireSec1" style={{paddingTop : '2rem'}}>
                    <div className="d-flex justify-content-center mt-4 mb-4">
                        <img style={{height : '5rem'}} src={Asset4} alt=""/>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        <h2 className="pt-1 d-inline" style={{textAlign : 'center' , borderBottom : "5px solid var(--primary-adsil-color)" , fontWeight : 'bold'}}> PARTENAIRE </h2>
                    </div>
                    <div className="d-flex justify-content-center pt-lg-3 pb-lg-3 pt-1 pb-1">
                        <h2  className="pt-1 d-inline secondaryTitle" style={{textAlign : 'center' }}> DEVENEZ NOTRE CHAUFFEUR PARTENAIRE</h2>
                    </div>
                    <div className="row mr-0 ml-0 justify-content-center">
                        <div className="col-10 partenaireHighLight" >
                            L’application Adsil driver donne aux chauffeurs de taxi inter wilayas accès à une plateforme dans laquelle ils sont en relation direct avec les voyageurs.
                        </div>
                    </div>
                    <div className="d-flex justify-content-center pt-lg-3 pb-lg-3 pt-1 pb-1 mt-4">
                        <h2  className="pt-1 d-inline secondaryTitle " style={{textAlign : 'center' }}> Comment ? </h2>
                    </div>
                    <div className="row mr-0 ml-0 justify-content-center mb-4">
                        <div className="col-10 partenaireHighLight" >
                            Pour rejoindre notre communauté de entreprises-partenaires, rien de plus simple ! Il suffit de suivre les étapes suivantes :
                        </div>
                    </div>
                    <Comment switche={false} img={Comment1} title={'Inscrivez-vous'} content={'En quelques clics seulement et en toute simplicité, remplissez vos informations personnelles puis contactez notre call center.'}/>
                    <Comment switche={true} img={Comment2} title={'Prenez rendez-vous pour une formation'} content={"Une formation sur l'utilisation de l'application vous sera assurée afin de débloquer votre copte."}/>
                    <div className="mt-4 mb-2 d-flex justify-content-center">
                        <h2 className="pt-1 d-inline" style={{textAlign : 'center' , borderBottom : "5px solid var(--primary-adsil-color)" , fontWeight : 'bold'}}> FELICITATIONS !  </h2>
                    </div>
                    <div className=" row mr-0 ml-0 justify-content-center  mt-2 mb-2">
                        <div className="col-10 partenaireHighLight" >
                            Vous êtes désormais notre chauffeur partenaire. Planifiez dès maintenant vos voyages.                        </div>
                    </div>
                    <div className="row mr-0 ml-0 mt-4 mb-4 justify-content-center">
                        <img  id="felicitationImg"  src={Mobile} alt=""/>
                    </div>
                </div>
                <RanaLahna titleBlue={'عمر بلايصك من دارك'}  titleGray={'Nous sommes là pour vous accompagner !'} contentGray={'Contactez-nous au 0798769631'}/>
            </React.Fragment>
        )
    }
}